import { VisitModel } from "@common/models/VisitModel";
import { VisitService } from "@common/services/visitService";
import { flow, makeObservable, observable } from "mobx";

export class VisitStore {
    @observable visit: VisitModel | undefined = undefined;

    constructor() {
        makeObservable(this, undefined, { autoBind: true });
    }

    public getVisit = flow(function* (this: VisitStore, visitId: number) {
        this.visit = yield VisitService.getVisit(visitId);
    });
}
